import { gql as t } from "@apollo/client";
const a = t`
  query VerifyContractTransaction($input: GetTxnStatusInput) {
    getTxnStatus(input: $input)
  }
`;
export {
  a as default
};
//# sourceMappingURL=verifyContractTransaction.js.map
